<template>
<w-settings-detail title="스크립트 설정" :default-active-menu="activeMenu" :menu="menu" @change="onChangeMenu">
  <w-settings-content-template slot="activeView">
    <w-script-setting-list slot="content" ref="scriptSettingView" @reload-data="loadScriptList" :activeCompanyId="activeCompanyId" :total="total" :dataList="scriptList" :templateTypeList="templateTypeList" :selectedTitle="selectTitle"></w-script-setting-list>
  </w-settings-content-template>
</w-settings-detail>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import WSettingsDetail from '@/components/template/SettingsDetail';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WScriptSettingList from '@/views/settings/netdevice/ScriptSettings/component/ScriptSettingList';

export default {
  name: 'WScriptSettings',
  components: {
    WSettingsDetail,
    WSettingsContentTemplate,
    WScriptSettingList,
  },
  props: {
    activeView: String,
  },
  data() {
    return {
      total: 0,
      activeMenu: null,
      selectTitle: '',
      activeCompanyId: null,
      templateTypeList: [],
      menu: [],
      scriptList: [],
    };
  },
  watch: {
    activeView: {
      handler() {
        if (this.activeView === 'WScriptSettings') {
          const me = this;
          NetdeviceSettingAPI.getTemplateVendorList().then((response) => {
            if (response.data.success) {
              const menuData = response.data.data;
              forEach(menuData, (item) => {
                me.menu.push({
                  id: item.objCompanyName,
                  companyId: item.objCompanyId,
                  name: item.objCompanyName,
                  active: false,
                });
              });
              me.activeMenu = me.menu[0].id;
              me.activeCompanyId = me.menu[0].companyId;
            }
          });
          NetdeviceSettingAPI.getTemplateTypeList().then((response) => {
            if (response.data.success) {
              this.templateTypeList = response.data.data;
            }
          });
        }
      },
      immediate: true,
    },
    activeCompanyId: {
      handler() {
        this.selectTitle = `[${this.activeMenu}] 제어 스크립트 목록`;
        if (!isNil(this.activeCompanyId)) {
          this.loadScriptList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
      const selectedData = find(this.menu, (item) => item.name === menu);
      if (!isNil(selectedData)) {
        this.activeCompanyId = selectedData.companyId;
      }
    },
    loadScriptList() {
      const scriptSettingTable = this.$refs.scriptSettingView.$refs.scriptSettingTable;
      const tableParams = scriptSettingTable.getParameter();
      const params = {
        objCompanyId: this.activeCompanyId,
        ...tableParams,
      };
      NetdeviceSettingAPI.getTemplateVendorListByCompany(params).then((response) => {
        if (response.data.success) {
          this.scriptList = response.data.data;
          this.total = response.data.total;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/ScriptSettings/index.vue